// extracted by mini-css-extract-plugin
export default {"AppArticl":"AppArticlCardInCard_AppArticl__lYIPz","AppArticlTitle":"AppArticlCardInCard_AppArticlTitle__6aSlC","AppArticlContent":"AppArticlCardInCard_AppArticlContent__qH2VU"};